<template>
  <vx-card no-shadow>
    <!-- Img Row -->
    <div class="flex flex-wrap items-center mb-base">
      <vs-avatar :src="photoURL" size="70px" class="mr-4 mb-4" />
    </div>
    <!-- Info -->
    <vs-input class="w-full mb-base" label-placeholder="Username" v-model="username" disabled></vs-input>
    <vs-input class="w-full mb-base" label-placeholder="Name" v-model="profile.fullname"></vs-input>
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" @click="saveProfile">แก้ไขข้อมูล</vs-button>
    </div>
  </vx-card>
</template>
<script>
import auth from "@/services/authService"
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  data() {
    return {
      username: '',
      profile: {
        fullname: ''
      }
    }
  },
  methods: {
    reloadProfile() {
      auth.getProfile().then((profile) => {
        this.username = profile.username
        this.profile = {
          fullname: profile.fullname
        }
      })
    },
    selectFile() {
      this.$refs.fileInput.click()
    },
    getFile(e) {

      let _this = this

      function uploadImage(e) {
        _this.uploadSrc = e.target.result
      }

      let files = e.target.files
      let file = files[0]

      if (/image.*/.test(file.type)) {

        // จำกัดไฟล์ไม่เกิน 800k
        if (file.size > 800000) return;

        let reader = new FileReader()
        reader.onload = uploadImage
        reader.readAsDataURL(file)

        this.uploadFile = file
      }

    },
    cancelFile() {
      this.uploadSrc = null
      this.uploadFile = null
    },
    saveProfile() {

      let user = firebase.auth().currentUser;
      let self = this
      user.updateProfile({
        displayName: this.profile.fullname
      }).then(function() {
        // Update successful.
        self.reloadProfile()

        self.$store.dispatch('reloadProfile')

        self.$vs.notify({
          title: 'สำเร็จ!',
          text: 'แก้ไขข้อมูลเสร็จเรียบร้อย',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'success'
        });
      }).catch(function() {
        // An error happened.
        self.$vs.notify({
          title: 'ผิดพลาด!',
          text: 'แก้ไขข้อมูลไม่สำเร็จ',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.ActiveUser
    },
    photoURL() {
      if (this.uploadSrc)
        return this.uploadSrc

      return this.$store.state.ActiveUser.img || require("@/assets/images/portrait/small/default-avatar.png")
    }
  },
  created() {
    this.reloadProfile()
  }
}

</script>
<style>
.input-span-placeholder {
  font-size: 0.9rem !important;
}

</style>
